import { c as _c } from "react/compiler-runtime";
import React from "react";
interface MemesLeaderboardDropDescriptionProps {
  readonly description: string;
}
const MemesLeaderboardDropDescription: React.FC<MemesLeaderboardDropDescriptionProps> = t0 => {
  const $ = _c(2);
  const {
    description
  } = t0;
  let t1;
  if ($[0] !== description) {
    t1 = <div><p className="tw-text-iron-400 tw-mb-0">{description}</p></div>;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MemesLeaderboardDropDescription;